import axios from 'axios'
import { useWms } from '@/store/modules/wms.js'

const baseUrl = `${window.yunweiConfig.cdnServer}${window.yunweiConfig.cdnPath}`

export const getWms = (path, params) => {
  const url = `${baseUrl}/externals/htm/_wms/${window.yunweiConfig.wmsPath}/`
  return axios.get(url + path, { params })
}

// 获取Wms静态资源
export const getWmsStatic = (path, params = {}) => {
  const url = `${baseUrl}/externals/static/_wms/${window.yunweiConfig.wmsPath}/`
  return axios.get(url + path, { params })
}

// 获取 wms 资源模块的图
export const getWmsImageUrl = (path, params = {}) => {
  const url = `${baseUrl}/externals/img/_wms/${window.yunweiConfig.wmsPath}`
  return axios.get(url + path, { params })
}

// 获取 wms 版本好信息
export const getWmsVersion = () => {
  return getWmsStatic('_data/version/versionControl.json?' + Date.now())
}

// 获取games.js地址
export const getGamesJsUrl = () => {
  return `${baseUrl}/externals/js/_wms/${window.yunweiConfig.wmsPath}/electronicgames/games.js`
}

// // 获取Wms自定义表单数据
export const getWmsFormData = (formName) => {
  const wms = useWms()
  let sv = wms.wmsVersion
  let v = sv && sv.form ? sv.form[formName] : Date.now()
  return getWmsStatic(`_data/form/${formName}.json?${v}`)
}

// //获取banner信息
// export const getWmsBanner = () => {
//   let sv = store.getters.wmsVersion
//   let v = sv && sv.banner ? sv.banner : Date.now()
//   return getWmsStatic(`_data/_banner/banner.txt?${v}`)
// }

// //获取优惠信息
// export const getPromoData = (promoName) => {
//   let sv = store.getters.wmsVersion
//   let v = sv && sv.hasOwnProperty('promo') && sv.promo.hasOwnProperty(promoName) ? sv.promo[promoName] : Date.now()
//   return getWmsStatic(`_data/_promo/${promoName}.txt?${v}`)
// }

// //获取专题页信息
// export const getTopicData = (topicName) => {
//   let sv = store.getters.wmsVersion
//   let v =
//     sv && sv.hasOwnProperty('special_topic') && sv.special_topic.hasOwnProperty(topicName)
//       ? sv.special_topic[topicName]
//       : Date.now()
//   return getWmsStatic(`_data/_specialTopic/${topicName}.txt?${v}`)
// }

// //获取落地页信息
// export const getLandingPageData = () => {
//   let sv = store.getters.wmsVersion
//   let v = sv && sv.hasOwnProperty('maps') ? sv.maps : Date.now()
//   return getWmsStatic(`_data/indexMap/maps.txt?${v}`)
// }

// //获取白名单信息
// export const getWhiteListData = () => {
//   let sv = store.getters.wmsVersion
//   let v = sv && sv.hasOwnProperty('whiteList') && sv.whiteList ? sv.whiteList : Date.now()
//   return getWmsStatic(`_data/_whiteList/whiteList.json?${v}`)
// }

export default {
  getWms,
  getWmsStatic,
  getWmsFormData,
  getWmsImageUrl,
  getWmsVersion,
  getGamesJsUrl,
  // getWmsBanner,
  // getPromoData,
  // getTopicData,
  // getLandingPageData,
  // getWhiteListData,
}
